import { Box } from '@mui/material';
import React, { FC, PropsWithChildren } from 'react';

const ContentDetails: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        marginBottom: '.5em',
        overflow: 'hidden',
        gap: '0.75rem',
      }}
    >
      {children}
    </Box>
  );
};

export default ContentDetails;
